// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

enum AnnouncementTypeEnum {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  RESERVED_ALERT = "alert",
}
export { AnnouncementTypeEnum };